export default {
  title: 'Video Projects',
  titleAndImage: 'Video & Image Project',
  desc: 'Online Video and Image Creation Tool: one-click design, mixed editing, AI dubbing, background removal, multi-language and multi-size video adaptation, etc.',
  addProject: {
    add: 'Create Project',
    addBlank: 'Create Project - Video Editing',
    addAI: 'Create Project - AI Video Generating',
    popover: {
      addBlank: 'Video Editor',
      addTemplate: 'Layout Template',
      addAI: 'AI Video Generator',
    },
    success: 'Created Successfully',
  },
  tab: {
    normal: 'Video Editor',
    ai: 'AI Video Generator',
    aiBanner: 'URL to Image',
  },
  select: {
    name: 'Project Name',
    projectName: 'Product Name',
  },
  drop: {
    addProject: {
      title: 'Create Video Project',
    },
    text: 'Project Name',
    language: 'Language',
    cancal: 'Cancel',
    sure: 'Confirm',
    copyProject: {
      title: 'Duplicate Project',
    },
    delProject: {
      title: 'Delete Project',
      text: "This can't be undone. Are you sure to delete?",
      demoText:
        'This is a demo project, please contact sales if you need to restore it. Are you sure to delete?',
    },
  },
  empty: {
    title1: 'No Result',
    desc1:
      'Sorry, no eligible results were found. It is suggested to change to different search criteria.',
    title2: 'No Data',
    desc2: "You haven't made your own video yet, start doing it now!",
  },
  table: {
    name: 'Project Name and ID',
    operation: {
      title: 'Operations',
      lock: 'Lock',
      lockTips:
        'After locking, the project cannot be deleted and saved. Are you sure you to lock?',
      lockSuccessTips: 'Lock Successfully',
      unlock: 'Unlock',
      unlockText: 'Unlock',
      unlockTips:
        'After unlocking, the project can be deleted and saved. Are you sure you to unlock?',
      unlockSuccessTips: 'Unlock Successfully',
      lockText: 'Lock',
      copy: 'Copy',
      edit: 'Edit',
      prejectInfo: 'View Details',
      delete: 'Delete',
    },
    projectName: 'Product Name',
    language: 'Language',
    time: 'Duration',
    exportNum: 'Successfully Export',
    updateTime: 'Updated Time',
    createTime: 'Creation Time',
    projectLocked: 'The project is locked.',
    projectLockedDeleteTip: 'The project is locked and cannot be deleted.',
    projectLockedEditTip: 'The project is locked and cannot be edited.',
    groupTotal: 'Number of Variations',
    exportTotal: 'Number of export tasks',
    exportCountTips:
      'Number of successful exports/total number of exported works',
  },
  projectDrop: {
    tabs1: 'Project Details',
    tabs2: 'Export History',
    title1: 'Basic Information',
    info: {
      name: 'Project Name',
      id: 'Project ID',
      time: 'Project Duration',
      exportNum: 'Export Times',
      founder: 'Creator',
      updater: 'Person Last Updated',
      updateTime: 'Updated Time',
      productName: 'Product Name',
      templateName: 'Template Name',
      ratios: 'Project Ratio',
      mainRatio: 'Main Creative Ratio',
      languages: 'Project Language',
    },
    title2: 'Associated Promoted Products',
    associate: {
      title: 'No Data',
      desc: 'Associate projects with existing product!',
      add: 'Associate with Promoted product',
      select: 'Choose Promoted product',
      new: 'Add Promoted product',
      placeholder: 'Please Choose by Searching Keywords',
      info: {
        package: 'Package Name',
        desc: 'Description',
      },
    },
    subtitle: {
      editAndExport: 'Edit & Export Information',
    },
  },
  filter: {
    fabrication: {
      placeholder: 'Method of making',
      normal: 'General Creation',
      batch: 'Batch Production',
      simple: 'Quick Replacement',
    },
  },
  rulesTips: 'The Project Name cannot be empty.',
  titleTips: 'Work name cannot be empty',
}
